import { coverageDTO } from "./coverageDTO";
import { PerformanceAnalysisDTO } from "./performanceAnalysisDTO";
import { PerformanceDTO } from "./performanceDTO";
import { TerrainAltitudeCutDTO } from "./TerrainAltitudeCutModel";
import { ConfigurationTerrain } from "./terrains";
import {ImpactAssessmentDTO} from "./grit/grit.calculation-dto";

export class CalcConfigInfo{
    calcConfig: string;
    calcId: number;
}

export abstract class AbstractWorkLogMsg {
    navAidList: NavaidCalcInfo[];
	terrains: ConfigurationTerrain[];
	id: string;
	projectId: number;
}

export class CalcCoverageLog extends AbstractWorkLogMsg{
    coverageDTO: coverageDTO;
}

export class CalcPerformanceLog extends AbstractWorkLogMsg{
    performanceDTO: PerformanceDTO;
}

export class CalcProcedurePerfLog extends AbstractWorkLogMsg{
    performanceAnalysisDTO: PerformanceAnalysisDTO;
}

export class CalcSectorizationLog extends AbstractWorkLogMsg{
    coverageDTO: coverageDTO;
}

export class CumulativeCoverageLog extends AbstractWorkLogMsg{
    coverageDTO: coverageDTO;
}

export class NavLocAssessLog extends AbstractWorkLogMsg{
    minSubAngle: number;
	docVal: number;
	isToUseVisibility: boolean;
	flightLevel: number;
}

export class TerrainAltitudeCutLog extends AbstractWorkLogMsg{
    terrainAltitudeCutDTO: TerrainAltitudeCutDTO;
}

export class NavaidCalcInfo{
    navaidId: string;
    name: string;
    type: string;
    icaocc: string;
}

//#region GRIT
export class CalcImpactAssessmentLog extends AbstractWorkLogMsg{
  calculationImpactAssessmentDTO: ImpactAssessmentDTO;
}

export class DeviceCalcInfo{
  id: string;
  name: string;
  type: string;

  devicePower: number;
  deviceGain: number;
  receiverPower: number;
  receiverGain: number;
}
//endregion

